export default function (page, section) {
  if (!page || !section) return "none";
  return `${page}-${section}`;
}
